export const washes = {

    state: () => ({
        washes: [],
        washesAddress: [],
        washesId: null,
        boxes: [],
        services: [],
        selectedBox: null,
        selectedWash: null
    }),
    
    actions: {
        async loadAllWashes({commit}) {
            try {
                const res = await fetch(
                    process.env.VUE_APP_API_DOMAIN+'/api/washes',
                    {
                        headers: {
                            'Content-Type': 'application/json', // Set appropriate content type
                        }
                    }
                    )
                    
                const washes = await res.json()
                
                commit('setWashes', washes)
                commit('setWashesAddress', washes)
            } catch (error) {
                console.error(error)
            }
        },

        async loadWashPosts({commit}, washId) {
            if(!washId) { 
                return 
            }

            const res = await fetch(
                process.env.VUE_APP_API_DOMAIN+'/api/washes/'+washId+'/boxes'
                )
            const boxes = await res.json()

            commit('setWashBoxes', boxes)
        },

        async loadRobotServices({commit}, robotId) {
            if(!robotId) { 
                return 
            }

            const res = await fetch(
                process.env.VUE_APP_API_DOMAIN+'/api/washes/boxes/'+robotId+'/programs'
                )
            const services = await res.json()

            commit('setWashRobotServices', services)
        },

        loadSelectedWash({commit, dispatch, state}, idWash) {

            if(!state.washes.length) {

                dispatch('loadAllWashes')
                .then(()=>{
                    commit('setSelectedWash', idWash)
                })
                return
            }

            commit('setSelectedWash', idWash)
        },

        selectedBox({commit}, idWash) {
            commit('setSelectedBox', idWash)
        }
    },
    mutations: {
        setWashes(state, washes){
            if(!washes) {
                state.washes = []
            }
            
            state.washes = washes.data
        },
        setWashesAddress(state, washes) {
            if(washes){
                state.washesAddress = []

                const activWashes = washes.data.filter( wash => wash.washGroupId)

                activWashes.every(wash => {
                    let address = {
                        value: wash.id,
                        name: `м. ${wash.city}, ${wash.address}`,
                        region: wash.region,
                        city: wash.city
                    }
                    return state.washesAddress.push(address);
                })
            }

        },
        setWashBoxes(state, boxes) {
            if(boxes){
                if(state.boxes.length) {
                    state.boxes= []
                }
                let count = 1;
                let coutRobots = 1;
                boxes.data.every(box => {

                    let boxes = {
                        value: box.id,
                        name: box.name,
                        type: box.type,
                        count: count
                    }

                    if(box.type == 'robot') {
                        boxes.name = `${coutRobots++} робот`;
                    } else {
                        boxes.name = box.type != 'vacuum' ? `${box.number} пост` : `${count++} порохотяг`;
                    }

                    return state.boxes.push(boxes);
                })
            }
        },
        setWashRobotServices(state, services) {
            if(services){
                if(state.services.length) {
                    state.services= []
                }
                let count = 1;

                services.data.every(service => {

                    let serviceItem = {
                        value: service.price,
                        name: `${service.name}`,
                        description: service.desc,
                        type: service.id,
                        count: count
                    }

                    return state.services.push(serviceItem);
                })
            }
        },
        setSelectedWash(state, washId) {
           
            let wash = state.washes.filter(item => item.id == washId)
            state.selectedWash = wash[0]

        },

        setSelectedBox(state, boxId) {
            let box = state.boxes.filter(item => item.value == boxId)
            state.selectedBox = box[0]
        }
    },

    getters: {
        getWashes( state ){
            return state.washes
        },
        getWashesAddress( state ){
            return state.washesAddress
        },
        getWashBoxes( state ) {
            return state.boxes
        },
        getWashRobotServices( state ) {
            return state.services
        },
        getSelectedWash( state ) {
            return state.selectedWash
        },
        getSelectedBox( state ) {
            return state.selectedBox
        }
    },
}